/**
 * TotalBreakdownCard.jsx — جولة تصحيح 2026-10-14 (المرحلة 2، البند 5)
 *
 * بطاقة دائمة للقراءة فقط: «تفكيك إجمالي العملاء» — تقرأ حصراً من
 * core.customer_population.total_customer_breakdown عبر GET
 * /customers/bonat/total-breakdown. لا حساب في المتصفح.
 */
import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const arNum = (n) => (n || 0).toLocaleString("ar");

export default function TotalBreakdownCard() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get("/customers/bonat/total-breakdown")
      .then((r) => { setData(r.data); setErr(null); })
      .catch((e) => setErr(e?.response?.status === 403 ? null : "تعذّر تحميل تفكيك إجمالي العملاء"));
  }, []);

  if (err) return (
    <div data-testid="total-breakdown-error" style={{ color: "#B91C1C", fontSize: 13 }}>{err}</div>
  );
  if (!data) return null;

  return (
    <section data-testid="total-breakdown-card" style={{
      marginBottom: 24, padding: 20, borderRadius: 16, background: "#FFFFFF",
      border: "2px solid rgba(124,58,237,0.25)",
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: "#5B21B6" }}>
          🧩 تفكيك إجمالي العملاء
        </h2>
        {data.has_violation && (
          <span data-testid="total-breakdown-violation-badge" style={{
            padding: "4px 10px", borderRadius: 999, background: "#FEE2E2",
            color: "#B91C1C", fontSize: 12, fontWeight: 800 }}>
            ⚠ يحتاج مراجعة
          </span>
        )}
      </div>

      <div style={{ fontSize: 13, color: "#5B21B6", fontWeight: 700, marginTop: 10 }}>
        إجمالي عملاء رتم: <b data-testid="total-breakdown-retm-total">{arNum(data.retm_total)}</b>
      </div>

      <table style={{ width: "100%", marginTop: 12, borderCollapse: "collapse", fontSize: 13 }}>
        <thead>
          <tr style={{ borderBottom: "2px solid #EDE9FE", color: "#78716C" }}>
            <th style={{ textAlign: "right", padding: "6px 4px" }}>الفئة</th>
            <th style={{ textAlign: "left", padding: "6px 4px" }}>العدد</th>
          </tr>
        </thead>
        <tbody>
          {(data.categories || []).map((c) => (
            <tr key={c.code} data-testid={`total-breakdown-row-${c.code}`}
                style={{ borderBottom: "1px solid #F5F3FF" }}>
              <td style={{ padding: "8px 4px", fontWeight: c.code === "unclassified" ? 800 : 600,
                           color: c.code === "unclassified" && c.count > 0 ? "#B91C1C" : "#3D2A1C" }}>
                {c.label_ar}
              </td>
              <td style={{ padding: "8px 4px", textAlign: "left", fontWeight: 700 }}>
                {arNum(c.count)}
              </td>
            </tr>
          ))}
          <tr style={{ borderTop: "2px solid #EDE9FE" }}>
            <td style={{ padding: "8px 4px", fontWeight: 800, color: "#5B21B6" }}>المجموع</td>
            <td data-testid="total-breakdown-sum" style={{ padding: "8px 4px", textAlign: "left", fontWeight: 800, color: "#5B21B6" }}>
              {arNum(data.sum)}
            </td>
          </tr>
        </tbody>
      </table>

      <div data-testid="total-breakdown-diff" style={{
        marginTop: 10, fontSize: 12, color: data.diff !== 0 ? "#B91C1C" : "#78716C", fontWeight: 700 }}>
        الفرق عن إجمالي عملاء رتم: {arNum(data.diff)}
      </div>
    </section>
  );
}
